var map = {
	"./button01en.png": "RlGe",
	"./button01zh-tw.png": "oJnr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "devU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img ^\.\/button01.*\.png$
// module id = devU
// module chunks = 1